import { CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './modules/home/home.component';
import { AuthModule } from './modules/auth/auth.module';
import { CoreModule } from './modules/core/core.module';
import { ExpedienteModule } from './modules/expediente/expediente.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilModule } from './modules/util/util.module';
import {
  HttpClient,
  HttpClientModule,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi
} from '@angular/common/http';
import { AlertaModule } from './modules/alerta/alerta.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { httpInterceptor } from './interceptor/http.interceptor';
import { authExpiredInterceptor  } from './interceptor/auth.interceptor';
import { VisualizacionModule } from './modules/visualizacion/visualizacion.module';
import {
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaModule,
  RecaptchaV3Module,
} from 'ng-recaptcha';
import { errorInterceptor } from './interceptor/error.interceptor';
import { ConfigurarCuentaAdministrativaComponent } from './modules/configuracion-cuenta/configurar-cuenta-administrativa/configurar-cuenta-administrativa.component';
import { ConfigurarCuentaComponent } from './modules/configuracion-cuenta/configurar-cuenta/configurar-cuenta.component';
import { CrearDemandaJurisdiccionalComponent } from './modules/tramites/supersalud/crear-demanda-jurisdiccional/crear-demanda-jurisdiccional.component';
import { GlosarioEntidadComponent } from './modules/glosario/glosario-entidad/glosario-entidad.component';
import { GlosarioService } from './services/glosario-entidad.service';
import { TramitesModule } from './modules/tramites/tramites.module';
import { NgxSimpleBreadcrumbModule } from 'ngx-simple-breadcrumb';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { PreguntasFrecuentesComponent } from './modules/preguntas-frecuentes/preguntas-frecuentes.component';
import { ToastrModule } from 'ngx-toastr';
import { ListaAdministradoresComponent } from './modules/administracion-usuarios/lista-administradores/lista-administradores.component';
import { CrearAdministradorComponent } from './modules/administracion-usuarios/crear-administrador/crear-administrador.component';
import { ModificarAdministradorComponent } from './modules/administracion-usuarios/modificar-administrador/modificar-administrador.component';
import { VisualizarAdministradorComponent } from './modules/administracion-funcional/visualizar-administrador/visualizar-administrador.component';
import { ObservatorioModule } from './modules/observatorio/observatorio.module';
import { IntegradorModule } from './modules/integrador/integrador.module';
import { FormulariosEnviadosComponent } from './modules/integrador/formularios-enviados/formularios-enviados.component';
import { GestionPlantillasCorreoComponent } from './modules/administracion-usuarios/gestion-plantillas-correo/gestion-plantillas-correo.component';
import { QuillModule } from 'ngx-quill';
import { GestionEntidadesComponent } from './modules/administracion-usuarios/gestion-entidades/gestion-entidades.component';
import { GestionAlertasComponent } from './modules/administracion-usuarios/gestion-alertas/gestion-alertas.component';
import { DashboardComponent } from './modules/administracion-usuarios/dashboard/dashboard.component';
import { UltimosCambiosComponent } from './modules/administracion-usuarios/ultimos-cambios/ultimos-cambios.component';
import { UltimosUsuariosComponent } from './modules/administracion-usuarios/ultimos-usuarios/ultimos-usuarios.component';

import { ActividadComponent } from './modules/administracion-usuarios/actividad/actividad.component';

import { CalendarModule } from 'primeng/calendar';
import { MetricasEntidadComponent } from './modules/metricas-entidad/metricas-entidad.component';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';

import { UserDashboardComponent } from './modules/dashboard/user-dashboard/user-dashboard.component';
import { SocketService } from './services/socket.service';
import { ProcessService } from './services/process.service';
import { NotificationService } from './services/notification.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { EncuestasModule } from './modules/encuestas/encuestas.module';
import { JustinoModule } from './modules/justino/justino.module';
import { ProcesosSupersociedadesInsolvenciaComponent } from './modules/visualizacion/procesos_supersociedades_insolvencia/procesos-supersociedades-insolvencia.component';
import { GestionGlosarioComponent } from './modules/administracion-usuarios/gestion-glosario/gestion-glosario.component';
import { FormEditarGlosarioComponent } from './modules/forms/form-editar-glosario/form-editar-glosario.component';
import { GestionPreguntasFrecuentesComponent } from './modules/administracion-usuarios/gestion-preguntas-frecuentes/gestion-preguntas-frecuentes.component';
import { FormEditarPreguntasFrecuentesComponent } from './modules/forms/form-editar-preguntas-frecuentes/form-editar-preguntas-frecuentes.component';
import { GestionInteroperabilidadComponent } from './modules/administracion-usuarios/gestion-interoperabilidad/gestion-interoperabilidad.component';
import { ValidacionDocumentosComponent } from './modules/validacion-documentos/validacion-documentos.component';
import { GestionParametrizacionComponent } from './modules/administracion-usuarios/gestion-parametrizacion/gestion-parametrizacion.component';
import { FormEditarParametrizacionComponent } from './modules/forms/form-editar-parametrizacion/form-editar-parametrizacion.component';
import { ParametrizacionEntidadesComponent } from './modules/parametrizacion-entidades/parametrizacion-entidades.component';
import { IngresarCorreoOtpComponent } from './modules/otp/ingresar-correo-otp/ingresar-correo-otp.component';
import { VerificarCodigoOtpComponent } from './modules/otp/verificar-codigo-otp/verificar-codigo-otp.component';
import { VisualizarDocumentosComponent } from './modules/otp/visualizar-documentos/visualizar-documentos.component';
import { EdicionDocumentoAdjuntoComponent } from './modules/administracion-usuarios/edicion-documento-adjunto/edicion-documento-adjunto.component';
import { GestionEventosEntidadComponent } from './modules/administracion-usuarios/gestion-eventos-entidad/gestion-eventos-entidad.component';
import { environment } from '../environments/environment';
import { ModalGestionEventosEntidadComponent } from './modules/administracion-usuarios/gestion-eventos-entidad/modal-gestion-eventos-entidad/modal-gestion-eventos-entidad.component';
import { TableroResumenCiudadanoComponent } from './modules/administracion-usuarios/tablero-resumen-ciudadano/tablero-resumen-ciudadano.component';
import { UsuariosGestoresComponent } from './modules/empresas/usuarios-gestores/usuarios-gestores.component';
import { AdministracionSolicitudesPJComponent } from './modules/administracion-funcional/administracion-solicitudes-pj/administracion-solicitudes-pj.component';
import { ModalDatosObservatorioComponent } from './modules/empresas/modal-datos-observatorio/modal-datos-observatorio.component';

function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ConfigurarCuentaAdministrativaComponent,
    ConfigurarCuentaComponent,
    GlosarioEntidadComponent,
    CrearDemandaJurisdiccionalComponent,
    CrearDemandaJurisdiccionalComponent,
    PreguntasFrecuentesComponent,
    ListaAdministradoresComponent,
    CrearAdministradorComponent,
    ModificarAdministradorComponent,
    VisualizarAdministradorComponent,
    FormulariosEnviadosComponent,
    MetricasEntidadComponent,
    GestionPlantillasCorreoComponent,
    GestionEntidadesComponent,
    GestionAlertasComponent,
    DashboardComponent,
    UltimosCambiosComponent,
    UltimosUsuariosComponent,
    VisualizarAdministradorComponent,
    ActividadComponent,
    UserDashboardComponent,
    ProcesosSupersociedadesInsolvenciaComponent,
    GestionGlosarioComponent,
    FormEditarGlosarioComponent,
    GestionPreguntasFrecuentesComponent,
    FormEditarPreguntasFrecuentesComponent,
    GestionInteroperabilidadComponent,
    ValidacionDocumentosComponent,
    GestionParametrizacionComponent,
    FormEditarParametrizacionComponent,
    ParametrizacionEntidadesComponent,
    IngresarCorreoOtpComponent,
    VerificarCodigoOtpComponent,
    VisualizarDocumentosComponent,
    ParametrizacionEntidadesComponent,
    EdicionDocumentoAdjuntoComponent,
    ParametrizacionEntidadesComponent,
    GestionEventosEntidadComponent,
    ModalGestionEventosEntidadComponent,
    TableroResumenCiudadanoComponent,
    UsuariosGestoresComponent,
    AdministracionSolicitudesPJComponent,
    ModalDatosObservatorioComponent,
  ],
  imports: [

    QuillModule,
    BrowserModule,
    PowerBIEmbedModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    UtilModule,
    AuthModule,
    CoreModule,
    ExpedienteModule,
    AlertaModule,
    VisualizacionModule,
    RecaptchaModule,
    RecaptchaV3Module,
    TramitesModule,
    NgxSimpleBreadcrumbModule,
    NgSelectModule,
    NgxSimpleBreadcrumbModule,
    CalendarModule,
    ToastrModule.forRoot(),
    ObservatorioModule,
    GoogleTagManagerModule.forRoot({
      id: 'GTM-5GT29HSC',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      defaultLanguage: 'es',
    }),
    IntegradorModule,
    EncuestasModule,
    JustinoModule
  ],
  providers: [
    GlosarioService,
    provideHttpClient(
      withInterceptors([
        httpInterceptor,
        errorInterceptor,
        authExpiredInterceptor
      ])
    ),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaSiteKey,
    },
    SocketService,
    ProcessService,
    NotificationService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
